export default function mapMeta(cmsData) {
	return {
		cms_base_id: cmsData?.base_movie_id,
		cms_id: cmsData?.movie_id,
		dataLayer: {
			essence_genre: cmsData?.dataLayer?.essenceGenre,
			genre_1: cmsData?.dataLayer?.magicGenre,
			imdb_id: cmsData?.dataLayer?.imdbId,
		},
		dates: {
			boxOffice: cmsData?.dates?.ticketing,
			release: cmsData?.dates?.release,
		},
		hubUrl: cmsData?.region?.domain_name ? `https://${cmsData.region.domain_name}` : undefined,
		id: cmsData?.thundr_id,
		title: {
			locale: cmsData?.title,
			localeSlug: cmsData?.slug,
		},
	};
}